import React, { FC, useState } from 'react';

import { AccommodationType } from '../../services/apis/accommodation/types';
import ExpandableText from '../ExpandableText/ExpandableText';
import FullscreenModal from '../FullscreenModal/FullscreenModal';
import SanitizeHTML from '../SanitizeHTML/SanitizeHTML';

const DESCRIPTION_CLAMP = 2;

interface AccommodationInfoProps {
  accommodation: AccommodationType;
  collapseDescription?: boolean;
}

const AccommodationInfo: FC<AccommodationInfoProps> = ({ accommodation, collapseDescription }) => {
  const { name, accommodationInfo, campingMapUrl } = accommodation;

  const [visible, setVisible] = useState(false);

  return (
    <>
      {accommodationInfo && (
        <div className="mb-4">
          {collapseDescription ? (
            <ExpandableText
              text={<SanitizeHTML>{accommodationInfo}</SanitizeHTML>}
              clamp={DESCRIPTION_CLAMP}
            />
          ) : (
            <SanitizeHTML>{accommodationInfo}</SanitizeHTML>
          )}
        </div>
      )}
      {campingMapUrl && (
        <>
          <a
            href={campingMapUrl}
            target="_blank"
            rel="noreferrer"
            onClick={e => {
              e.preventDefault();
              setVisible(true);
            }}
            className="mb-4 d-block"
            style={{ cursor: 'zoom-in' }}
          >
            <img className="d-block w-100" src={campingMapUrl} alt={name} />
          </a>
          <FullscreenModal visible={visible} close={() => setVisible(false)}>
            <img className="d-block" src={campingMapUrl} alt={name} />
          </FullscreenModal>
        </>
      )}
    </>
  );
};

export default AccommodationInfo;
